<template>
  <div/>
</template>

<script>
export default {
  watch: {
    $route(to) {
      document.dispatchEvent(new CustomEvent('trackPage', {detail: {path: to.path}}));
    }
  },
  mounted() {
    document.addEventListener('trackPage', e => {
      this.trackPage(e.detail);
    });
    document.addEventListener('trackAudio', e => {
      this.trackAudio(e.detail);
    });
    this.trackPage({path: this.$route.path});
  },
  methods: {
    trackPage(track) {
      const _paq = window._paq = window._paq || [];
      _paq.push(['trackEvent', 'Page', 'open', track.path]);
    },
    trackAudio(track) {
      const _paq = window._paq = window._paq || [];
      _paq.push(['trackEvent', 'Song', 'play', track.title + ' (' + track.style + ')']);
    }
  }
}

</script>